import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table } from 'react-bootstrap';
import { getCourse, getTabs, AssignTabsToCourse, getAllCourseTabs, updateTabsForCourse } from "../../../api/pageconfiguration"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PageConfiuration() {
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [courses, setCourses] = useState([]);
    const [selectedTabs, setSelectedTabs] = useState([]);
    const [tabs, setTabs] = useState([]);
    const [error, setError] = useState('');
    const [courseTabs, setCourseTabs] = useState([]);
    const [editCourseId, setEditCourseId] = useState(null);
    const [errors, setErrors] = useState({});

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [courseResponse, tabsResponse, courseTabsResponse] = await Promise.all([
                    getCourse(token),
                    getTabs(token),
                    getAllCourseTabs(token),
                ]);

                setCourses(courseResponse.data);
                setTabs(tabsResponse.data);
                console.log("Course tabs response:", courseTabsResponse.data)
                setCourseTabs(courseTabsResponse.data);
                const groupedData = {};

                courseTabsResponse.data.forEach(item => {
                    const courseId = item.course.id;
                    if (!groupedData[courseId]) {
                        groupedData[courseId] = {
                            id: courseId,
                            courseName: item.course.courseName,
                            tabs: []
                        };
                    }
                    groupedData[courseId].tabs.push(item.tab);
                });

                setCourseTabs(Object.values(groupedData));

            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);



    const handleCourseChange = (e) => {
        const courseId = e.target.value;
        setSelectedCourse((prevSelected) =>
            prevSelected.includes(courseId)
                ? prevSelected.filter((id) => id !== courseId)
                : [...prevSelected, courseId]
        );
        setErrors((prev) => ({ ...prev, selectedCourse: "" }));
    };

    const handleTabChange = (e) => {
        const tabid = e.target.value;
        setSelectedTabs((prevSelected) =>
            prevSelected.includes(tabid)
                ? prevSelected.filter((id) => id !== tabid)
                : [...prevSelected, tabid]
        );
        setErrors((prev) => ({ ...prev, selectedTabs: "" }));
    };

    const handleSubmit = async () => {
        const newErrors = {};
        if (selectedCourse.length === 0) {
            newErrors.selectedCourse = "Please select at least one course.";
        }
        if (selectedTabs.length === 0) {
            newErrors.selectedTabs = "Please select at least one tab.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        if (!editCourseId) {
            const isDuplicate = selectedCourse.some((courseId) => {
                const matchedCourse = courseTabs.find((ct) => String(ct.id) === String(courseId));
                if (!matchedCourse) return false;

                const existingTabIds = new Set(matchedCourse.tabs.map((tab) => String(tab.id)));
                const selectedTabIds = new Set(selectedTabs.map(String));

                let allTabsAlreadyAssigned = true;
                for (let tabId of selectedTabIds) {
                    if (!existingTabIds.has(tabId)) {
                        allTabsAlreadyAssigned = false;
                        break;
                    }
                }

                return allTabsAlreadyAssigned;
            });

            if (isDuplicate) {
                toast.warn("This configuration already exists.");
                return;
            }
        }

        try {
            if (editCourseId) {
                await updateTabsForCourse(editCourseId, token, selectedTabs);
                toast.success("Course tabs updated successfully!");
                setEditCourseId(null);
            } else {
                for (const courseId of selectedCourse) {
                    await AssignTabsToCourse(courseId, token, selectedTabs);
                }
                toast.success("Tabs assigned successfully!");
            }

            const updatedCourseTabsResponse = await getAllCourseTabs(token);

            const groupedData = {};
            updatedCourseTabsResponse.data.forEach(item => {
                const courseId = item.course.id;
                if (!groupedData[courseId]) {
                    groupedData[courseId] = {
                        id: courseId,
                        courseName: item.course.courseName,
                        tabs: []
                    };
                }
                groupedData[courseId].tabs.push(item.tab);
            });
            setCourseTabs(Object.values(groupedData));

            setSelectedCourse([]);
            setSelectedTabs([]);
            setErrors({});
        } catch (err) {
            console.error("Error assigning/updating tabs:", err);
            toast.error("Failed to assign/update tabs. Please try again.");
        }
    };

    const handleEdit = (courseTab) => {
        setEditCourseId(courseTab.id); 
        setSelectedCourse([String(courseTab.id)]); 
        setSelectedTabs(courseTab.tabs.map((tab) => String(tab.id))); 
        console.log("Editing Course:", courseTab.courseName);
        console.log("Selected Tabs:", courseTab.tabs.map((tab) => tab.id));
    };
    const handleCancel = () => {
        setSelectedCourse([]);
        setSelectedTabs([]);
        setErrors({});
        setEditCourseId(null);
    }

    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Page Configuration</p>
                        <Form>
                            <Row className='mt-4'>

                                <Row className="mb-3">

                                    <Form.Label
                                        className="col-sm-3 col-form-label form-label"
                                        htmlFor="courseDropdown"
                                    >
                                        Course<span className="text-danger">*</span>
                                    </Form.Label>
                                    <Col className="mb-3">

                                        <DropdownButton
                                            title={
                                                selectedCourse.length > 0
                                                    ? courses
                                                        .filter((course) => selectedCourse.includes(String(course.id)))
                                                        .map((course) => course.courseName)
                                                        .join(", ")
                                                    : "Select Course"
                                            }
                                            id="course-dropdown"
                                            className="course-dropdown"
                                        >

                                            <div style={{ padding: '10px' }}>
                                                {courses.map((course) => (
                                                    <Form.Check
                                                        key={course.id}
                                                        type="checkbox"
                                                        id={`course-${course.id}`}
                                                        value={course.id}
                                                        label={course.courseName}
                                                        checked={selectedCourse.includes(String(course.id))} 
                                                        onChange={handleCourseChange}
                                                    />

                                                ))}
                                            </div>
                                        </DropdownButton>
                                        {errors.selectedCourse && (
                                            <div
                                                style={{
                                                    color: "red",
                                                    fontSize: "13px",
                                                    marginTop: "3px",
                                                }}
                                            >
                                                {errors.selectedCourse}
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Form.Label
                                        className="col-sm-3 col-form-label form-label"
                                        htmlFor="courseDropdown"
                                    >
                                        Tabs<span className="text-danger">*</span>
                                    </Form.Label>
                                    <Col sm={9} className="mb-3 mb-lg-0">
                                        <DropdownButton
                                            title={
                                                selectedTabs.length > 0
                                                    ? tabs
                                                        .filter((tab) => selectedTabs.includes(String(tab.id)))
                                                        .map((tab) => tab.tabs)
                                                        .join(", ")
                                                    : "Select Tab"
                                            }
                                            id="tab-dropdown"
                                            className="course-dropdown"
                                        >
                                            <div style={{ padding: '10px' }}>
                                                {tabs.map((tab) => (
                                                    <Form.Check
                                                        key={tab.id}
                                                        type="checkbox"
                                                        id={`tab-${tab.id}`}
                                                        value={tab.id}
                                                        label={tab.tabs}
                                                        checked={selectedTabs.includes(String(tab.id))} 
                                                        onChange={handleTabChange}
                                                    />
                                                ))}
                                            </div>
                                        </DropdownButton>
                                        {errors.selectedTabs && (
                                            <div
                                                style={{
                                                    color: "red",
                                                    fontSize: "13px",
                                                    marginTop: "3px",
                                                }}
                                            >
                                                {errors.selectedTabs}
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                            </Row>

                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3">
                                    <Button variant="primary" type="button"
                                        onClick={handleSubmit}
                                    >
                                        {editCourseId ? "Update" : "Submit"}
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>

                            <Row>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Course</th>
                                            <th>Tabs</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {courseTabs.length === 0 ? (
                                            <tr>
                                                <td colSpan="3" className="text-center">No courses with assigned tabs found.</td>
                                            </tr>
                                        ) : (
                                            courseTabs
                                                .filter((courseTab) => Array.isArray(courseTab.tabs) && courseTab.tabs.length > 0)
                                                .map((courseTab) => (

                                                    <tr key={courseTab.id}>
                                                        <td>
                                                            <Button variant="secondary" onClick={() => handleEdit(courseTab)}>
                                                                <i className="bi bi-pencil-fill me-2" />Edit
                                                            </Button>
                                                        </td>
                                                        <td>{courseTab.courseName}</td>
                                                        <td>
                                                            {Array.isArray(courseTab.tabs)
                                                                ? courseTab.tabs.map((tab) => tab.tabs).join(", ")
                                                                : "No tabs assigned"}
                                                        </td>

                                                    </tr>
                                                ))
                                        )}
                                    </tbody>

                                </Table>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>


        </>
    );
}

export default PageConfiuration;